export const FETCH_TRANSACTION_URL = "/payin/status";
export const FETCH_GATEWAY_URL = "/payin/public/fetch";
export const SEND_PAYIN_PROOF_URL = "/payin/public/proof/utr"
export const CANCEL_TRANSACTION_URL = ""



